import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c453fe58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "keyword-form" }
const _hoisted_2 = { class: "table-wrapper" }
const _hoisted_3 = { class: "filter" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Delete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_language_selector = _resolveComponent("language-selector")!
  const _component_keyword_table = _resolveComponent("keyword-table")!
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_input, {
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          class: "searchbox",
          placeholder: _ctx.searchBoxPlaceholder,
          onSetData: _ctx.setSearchText
        }, null, 8, ["modelValue", "placeholder", "onSetData"]),
        (!_ctx.hideLanguage)
          ? (_openBlock(), _createBlock(_component_language_selector, {
              key: 0,
              class: "language",
              value: _ctx.selectedLanguage,
              "no-placeholder": "",
              onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('setSelectedLanguage', $event)))
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_keyword_table, {
        loading: _ctx.loading,
        "is-loaded": _ctx.isLoaded,
        "selected-keywords": _ctx.selectedKeywords,
        keywords: _ctx.keywords,
        onLoadMore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('loadMore', $event))),
        onSetSelectedKeyword: _ctx.setSelectedKeyword,
        onChangeMatchType: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('changeMatchType', $event)))
      }, null, 8, ["loading", "is-loaded", "selected-keywords", "keywords", "onSetSelectedKeyword"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_default_button, {
        class: "space",
        color: "purple",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('removeKeyword')))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "button", {}, undefined, true)
    ])
  ]))
}